import { Definition } from "../../../data/Definition";
import { ChartConfigManager } from "../ChartConfigManager";
import { IDimension, IFilter, IItem, IMeasure } from "../../../data/Query";

const currentVersion = "1";

type ConfigType = {
    version: string,
    dimension: IDimension[],
    measure: IMeasure[],
    spatial: IItem | null,
    filters: IFilter[]
};

export class StatsTimeSeriesConfigManager extends ChartConfigManager {
    private definition: Definition;

    constructor(definition: Definition) {
        super();

        this.definition = definition;
    }

    currentVersion(): string {
        return currentVersion;
    }

    isCurrentVersion(config: any): boolean {
        return config !== null && config.version !== undefined && config.version === currentVersion;
    }

    validate(config: any): boolean {
        return this.isCurrentVersion(config);
    }

    convert(config: any) {
        return this.isCurrentVersion(config) ? config : this.convertToCurrent(config);
    }

    convertToCurrent(config: any) {
        if (!config) {
            let newConfig = {} as ConfigType;
            newConfig.version = currentVersion;
            return newConfig;
        }

        return this.convertFromV1(config);
    }

    private convertFromV1(config: any): ConfigType {
        let newConfig = {} as ConfigType;
        newConfig.version = currentVersion;

        console.log('convertFromV1 > from', config);

        console.log('convertFromV1 > to', newConfig);

        return newConfig;
    }
}
